"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 当院紹介 メディア アコーディオン
 */
const jquery_1 = __importDefault(require("jquery"));
const className = "is-active";
const IntroductionMedia = () => {
    const items = document.querySelectorAll(".intro-Media");
    for (let i = 0; i < items.length; i++)
        appendEvent(items[i]);
};
const appendEvent = (item) => {
    const toggle = item.querySelector(".intro-Media_Toggle");
    toggle === null || toggle === void 0 ? void 0 : toggle.addEventListener("click", (event) => clickHandler(event, item), false);
};
const clickHandler = (event, target) => {
    const el = event.currentTarget;
    if (el) {
        const content = (0, jquery_1.default)(target).find(".intro-Media_Content");
        if (target.classList.contains(className)) {
            target.classList.remove(className);
            content.stop().slideUp(300);
        }
        else {
            target.classList.add(className);
            content.slideDown(300);
        }
    }
};
exports.default = IntroductionMedia;
